import { useNavigationV3Context } from './useNavigationV3Context'
import { useFeatureFlags } from 'hooks/useFeatureFlags'
import {
  COLLAPSED_WIDTH,
  EXPANDED_WIDTH,
  EXPANDED_WIDTH_REV_REC
} from 'components/NavigationV3/components/Container/Container'

export const useNavigationWidth = (): number => {
  const { data } = useNavigationV3Context()
  const flags = useFeatureFlags()
  return data.isNavigationCollapsed
    ? COLLAPSED_WIDTH
    : flags.useRevRec
      ? EXPANDED_WIDTH_REV_REC
      : EXPANDED_WIDTH
}
